;(function () {
  // Odometer-style count-up: each digit is a 0-9 column that rolls continuously,
  // so the count eases to a stop instead of ticking through whole numbers
  function init() {
    var els = document.querySelectorAll('.stat-number[data-count-to]')
    if (!els.length) return

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    var duration = 1500
    var span = 15

    function cascadeExtra(el) {
      var group = el.closest('.stat-pair') || el.parentElement
      if (!group) return 0
      var siblings = Array.prototype.slice.call(group.querySelectorAll('.stat-number[data-count-to]'))
      if (siblings.length < 2) return 0
      siblings.sort(function (a, b) {
        return parseInt(b.getAttribute('data-count-to'), 10) - parseInt(a.getAttribute('data-count-to'), 10)
      })
      return siblings.indexOf(el) * 250
    }

    function easeOutCubic(progress) {
      return 1 - Math.pow(1 - progress, 3)
    }

    function startFor(target) {
      return Math.max(target - span, 0)
    }

    function build(el, target) {
      var places = String(target).length
      var lineHeight = parseFloat(getComputedStyle(el).lineHeight)
      var height = isNaN(lineHeight) ? '1.2em' : lineHeight + 'px'
      // Digit rows are taller than the line and pulled back with negative margins, so the soft
      // edge fade only covers empty space and neighbouring digits stay out of view at rest
      var row = 'calc(' + height + ' * 1.2)'
      var bleed = 'calc(' + height + ' * -0.1)'
      var fade = 'linear-gradient(to bottom, transparent 0, #000 20%, #000 80%, transparent 100%)'

      el.textContent = ''
      el.setAttribute('aria-label', target + '%')

      var line = document.createElement('span')
      line.setAttribute('aria-hidden', 'true')
      line.style.cssText = 'display:inline-flex;align-items:center;vertical-align:top;height:' + height + ';line-height:' + height + ';'

      var columns = []
      for (var place = places - 1; place >= 0; place--) {
        var slot = document.createElement('span')
        slot.style.cssText =
          'display:inline-block;overflow:hidden;height:' + row + ';margin-block:' + bleed + ';-webkit-mask-image:' + fade + ';mask-image:' + fade + ';'
        var strip = document.createElement('span')
        strip.style.cssText = 'display:flex;flex-direction:column;will-change:transform;'
        for (var digit = 0; digit <= 10; digit++) {
          var cell = document.createElement('span')
          cell.style.cssText = 'display:block;height:' + row + ';line-height:' + row + ';'
          cell.textContent = digit % 10
          strip.appendChild(cell)
        }
        slot.appendChild(strip)
        line.appendChild(slot)
        columns.push({ place: place, slot: slot, strip: strip })
      }

      var percent = document.createElement('span')
      percent.textContent = '%'
      line.appendChild(percent)
      el.appendChild(line)
      el._odometer = { columns: columns, height: row }
    }

    // Each place rolls like a real odometer: the ones turn freely, and a higher place
    // only turns during the last step before it carries (59 to 60, 99 to 100)
    function render(el, value) {
      var odometer = el._odometer
      odometer.columns.forEach(function (column) {
        var unit = Math.pow(10, column.place)
        var carry = Math.min(Math.max((value % unit) - (unit - 1), 0), 1)
        var position = column.place === 0 ? value % 10 : (Math.floor(value / unit) % 10) + carry
        column.strip.style.transform = 'translateY(calc(' + -position + ' * ' + odometer.height + '))'

        // A new leading digit (the 1 in 100) grows to a measured digit width, so nothing jumps when it lands
        if (column.place > 0 && column.place === odometer.columns[0].place && odometer.columns.length > 1) {
          if (!odometer.digitWidth) odometer.digitWidth = odometer.columns[odometer.columns.length - 1].slot.getBoundingClientRect().width
          var reveal = Math.min(Math.max(value - (unit - 1), 0), 1)
          column.slot.style.opacity = reveal
          column.slot.style.width = odometer.digitWidth ? reveal * odometer.digitWidth + 'px' : reveal ? '' : '0px'
        }
      })
    }

    function animate(el) {
      var target = parseInt(el.getAttribute('data-count-to'), 10)
      if (isNaN(target)) return
      if (!el._odometer) build(el, target)
      if (reduceMotion) {
        render(el, target)
        return
      }

      var from = startFor(target)
      var delay = cascadeExtra(el)
      var start = null
      render(el, from)

      function step(ts) {
        if (start === null) start = ts + delay
        var progress = Math.min(Math.max((ts - start) / duration, 0), 1)
        render(el, from + (target - from) * easeOutCubic(progress))
        if (progress < 1) requestAnimationFrame(step)
        else render(el, target)
      }

      requestAnimationFrame(step)
    }

    function showFinal(el) {
      var target = parseInt(el.getAttribute('data-count-to'), 10)
      if (isNaN(target)) return
      if (!el._odometer) build(el, target)
      render(el, target)
    }

    els.forEach(function (el) {
      var target = parseInt(el.getAttribute('data-count-to'), 10)
      if (isNaN(target)) return
      build(el, target)
      render(el, startFor(target))
    })

    if (!('IntersectionObserver' in window)) {
      els.forEach(animate)
      return
    }

    // Counts once, on the way down; arriving from below (scrolling up) shows the final number
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return
          observer.unobserve(entry.target)
          if (entry.boundingClientRect.top > 0) animate(entry.target)
          else showFinal(entry.target)
        })
      },
      { threshold: 0.6 }
    )

    els.forEach(function (el) {
      observer.observe(el)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
